import { Config } from "../../configurations/config";
export const Timesheet_APIs = {
	HoursWorked_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetHoursWorked?date=`,
	GetProjects_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetProjectsAndNonProjects?Date=`,
	GetHours_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetHoursPerProjectPerDay`,
	Delete_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/RemoveProjectActivity?WorkSheetTaskId=`,
	AddProject_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/AddProjectActivity`,
	AddComment_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/AddTimeSheetComment`,
	GetSupervisorEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetAllEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=false`,
	GetWeeklyTimeSheet_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetWeeklyTimeSheet?EmpId=`,
	ApproveRejectTimeSheet_API: `${Config.server_url}${Config.api_prefix}/TimeSheet/ApproveRejectTimeSheetBySupervisor`,
	SaveHoursPerProject: `${Config.server_url}${Config.api_prefix}/TimeSheet/SaveHoursPerProjectPerDay`,
	SaveTimeSheet: `${Config.server_url}${Config.api_prefix}/TimeSheet/SaveTimeSheet`,
	SubmitTimeSheet: `${Config.server_url}${Config.api_prefix}/TimeSheet/SubmitTimeSheet`,
	RequestRejectTimesheet: `${Config.server_url}${Config.api_prefix}/TimeSheet/RequestRejectTimesheet`,
	GetWeekInformation: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetWeekInformation`,
	getDevOpsTasks: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetDevOpsLoggedHours`,
};
